/* global VXConfig */

import Translations from "../../utils/Translations";

const ft = (key) => Translations.get(`cams_filter.${key}`);

const ONLINE_FILTER = {online: {eq: true}};

const _KEYS = {
	COUNTRY:            'country',
	SKIN_TYPE:          'skinType',
	HAIR_COLOR:         'hairColor',
	BODY_TYPE:          'bodyType',
	BODY_MODIFICATIONS: 'bodyModifications',
	AGE:                'age',
	PUBIC_HAIR:         'pubicHair',
	EYE_COLOR:          'eyeColor',
	GENDER:             'gender',
	CUP_SIZE:           'cupSize',
	SEXUALITY:          'sexuality',
	NEW:                'new',
	SOFT_CHAT:          'softchat',
	LIVE_PREVIEW:       'livePreview',
	TOY_CONTROL:        'toyControl',
	PENIS_SIZE:         'penisSize',
	PHONE_SEX:          'service0900',
	SPOKEN_LANGUAGES:   'spokenLanguages',
	BIRTHDAY:           'birthday',
	MOBILE_VIDEOCALL:	'mobileVideoCall'
};

const _Filters = {
	COUNTRY:            { //eq
		KEY:   _KEYS.COUNTRY,
		VALUE: {
			DE: {KEY: 'DE', VALUE: {[_KEYS.COUNTRY]: {eq: 'DE'}}},
			ES: {KEY: 'ES', VALUE: {[_KEYS.COUNTRY]: {eq: 'ES'}}},
			PL: {KEY: 'PL', VALUE: {[_KEYS.COUNTRY]: {eq: 'PL'}}},
			FR: {KEY: 'FR', VALUE: {[_KEYS.COUNTRY]: {eq: 'FR'}}},
			RU: {KEY: 'RU', VALUE: {[_KEYS.COUNTRY]: {eq: 'RU'}}},
		}
	},
	SKIN_TYPE:          { //eq
		KEY:   _KEYS.SKIN_TYPE,
		VALUE: {
			ASIAN:  {KEY: 'ASIAN', VALUE: {[_KEYS.SKIN_TYPE]: {eq: 'ASIAN'}}},
			BLACK:  {
				KEY: 'BLACKSKINNED', VALUE: {
					or: [
						{[_KEYS.SKIN_TYPE]: {eq: 'BLACKSKINNED'}},
						{[_KEYS.SKIN_TYPE]: {eq: 'DARKSKINNED'}},
						{[_KEYS.SKIN_TYPE]: {eq: 'AFROAMERICAN'}}
					]
				}
			},
			LATINA: {KEY: 'LATINAMERICAN', VALUE: {[_KEYS.SKIN_TYPE]: {eq: 'LATINAMERICAN'}}},
		}
	},
	HAIR_COLOR:         { //eq
		KEY:   _KEYS.HAIR_COLOR,
		VALUE: {
			BLOND:         {KEY: 'BLOND', VALUE: {[_KEYS.HAIR_COLOR]: {eq: 'BLOND'}}},
			BROWN:         {KEY: 'BROWN', VALUE: {[_KEYS.HAIR_COLOR]: {eq: 'BROWN'}}},
			BLACK:         {KEY: 'BLACK', VALUE: {[_KEYS.HAIR_COLOR]: {eq: 'BLACK'}}},
			RED:           {KEY: 'RED', VALUE: {[_KEYS.HAIR_COLOR]: {eq: 'RED'}}},
			MULTICOLOURED: {KEY: 'MULTICOLOURED', VALUE: {[_KEYS.HAIR_COLOR]: {eq: 'MULTICOLOURED'}}},
		}
	},
	BODY_TYPE:          { //eq
		KEY:   _KEYS.BODY_TYPE,
		VALUE: {
			THIN:     {KEY: 'THIN', VALUE: {[_KEYS.BODY_TYPE]: {eq: 'THIN'}}},
			AVERAGE:  {KEY: 'AVERAGE', VALUE: {[_KEYS.BODY_TYPE]: {eq: 'AVERAGE'}}},
			ATHLETIC: {KEY: 'ATHLETIC', VALUE: {[_KEYS.BODY_TYPE]: {eq: 'ATHLETIC'}}},
			FAT:      {KEY: 'FAT', VALUE: {[_KEYS.BODY_TYPE]: {eq: 'FAT'}}},
		}
	},
	BODY_MODIFICATIONS: { //in
		KEY:   _KEYS.BODY_MODIFICATIONS,
		VALUE: {
			HEAVILYTATTOOED:  {KEY: 'HEAVILYTATTOOED', VALUE: {[_KEYS.BODY_MODIFICATIONS]: {contains: ['HEAVILYTATTOOED']}}},
			PECTORALPIERCING: {KEY: 'PECTORALPIERCING', VALUE: {[_KEYS.BODY_MODIFICATIONS]: {contains: ['PECTORALPIERCING']}}},
		}
	},
	SPOKEN_LANGUAGES:   {
		KEY:   _KEYS.SPOKEN_LANGUAGES,
		VALUE: {
			DE: {KEY: 'DE', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['DE']}}},
			EN: {KEY: 'EN', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['EN']}}},
			FR: {KEY: 'FR', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['FR']}}},
			IT: {KEY: 'IT', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['IT']}}},
			ES: {KEY: 'ES', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['ES']}}},
			DA: {KEY: 'DA', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['DA']}}},
			FI: {KEY: 'FI', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['FI']}}},
			NL: {KEY: 'NL', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['NL']}}},
			PL: {KEY: 'PL', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['PL']}}},
			PT: {KEY: 'PT', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['PT']}}},
			RU: {KEY: 'RU', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['RU']}}},
			TR: {KEY: 'TR', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['TR']}}},
			CZ: {KEY: 'CZ', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['CZ']}}},
			HU: {KEY: 'HU', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['HU']}}},
			RO: {KEY: 'RO', VALUE: {[_KEYS.SPOKEN_LANGUAGES]: {contains: ['RO']}}},
		}
	},
	AGE:                { //eq, lt, gt, lte, gte,
		KEY:   _KEYS.AGE,
		VALUE: {
			TEEN:    {
				KEY:   'TEEN',
				VALUE: {
					and: [
						{age: {gte: 18}},
						{age: {lte: 19}},
					]
				}
			},
			"20-29": {
				KEY:   '20-29',
				VALUE: {
					and: [
						{age: {gte: 20}},
						{age: {lte: 29}},
					]
				}
			},
			"30-39": {
				KEY:   '30-39',
				VALUE: {
					and: [
						{age: {gte: 30}},
						{age: {lte: 39}},
					]
				}
			},
			MILF:    {
				KEY:   'MILF',
				VALUE: {
					and: [
						{age: {gte: 40}},
						{age: {lte: 59}},
					]
				}
			},
			GRANDMA: {KEY: 'GRANDMA', VALUE: {age: {gte: 60}}}
		},
	},
	PUBIC_HAIR:         { //eq
		KEY:   _KEYS.PUBIC_HAIR,
		VALUE: {
			SHAVED:           {KEY: 'SHAVED', VALUE: {[_KEYS.PUBIC_HAIR]: {eq: 'SHAVED'}}},
			PARTIALLY_SHAVED: {KEY: 'PARTIALLY_SHAVED', VALUE: {[_KEYS.PUBIC_HAIR]: {eq: 'PARTIALLY_SHAVED'}}},
			HAIRY:            {KEY: 'HAIRY', VALUE: {[_KEYS.PUBIC_HAIR]: {eq: 'HAIRY'}}},
		}
	},
	EYE_COLOR:          { //eq
		KEY:   _KEYS.EYE_COLOR,
		VALUE: {
			BLUE:  {KEY: 'BLUE', VALUE: {[_KEYS.EYE_COLOR]: {eq: 'BLUE'}}},
			BROWN: {KEY: 'BROWN', VALUE: {[_KEYS.EYE_COLOR]: {eq: 'BROWN'}}},
			GREEN: {KEY: 'GREEN', VALUE: {[_KEYS.EYE_COLOR]: {eq: 'GREEN'}}},
			GREY:  {KEY: 'GREY', VALUE: {[_KEYS.EYE_COLOR]: {eq: 'GREY'}}},
		}
	},
	GENDER:             { //eq
		KEY:   _KEYS.GENDER,
		VALUE: {
			F:  {KEY: 'F', VALUE: {[_KEYS.GENDER]: {eq: 'F'}}},
			M:  {KEY: 'M', VALUE: {[_KEYS.GENDER]: {eq: 'M'}}},
			FM: {KEY: 'FM', VALUE: {or: [{[_KEYS.GENDER]: {eq: 'FM'}}, {[_KEYS.GENDER]: {eq: 'FF'}}]}},
			FF: {KEY: 'FF'},
			S:  {KEY: 'S', VALUE: {[_KEYS.GENDER]: {eq: 'S'}}},
		}
	},
	PENIS_SIZE:         { //eq
		KEY:   _KEYS.PENIS_SIZE,
		VALUE: {
			S:  {KEY: 'S', VALUE: {[_KEYS.PENIS_SIZE]: {eq: 'S'}}},
			M:  {KEY: 'M', VALUE: {[_KEYS.PENIS_SIZE]: {eq: 'M'}}},
			L:  {KEY: 'L', VALUE: {[_KEYS.PENIS_SIZE]: {eq: 'L'}}},
			XL: {KEY: 'XL', VALUE: {[_KEYS.PENIS_SIZE]: {eq: 'XL'}}},
		}
	},
	CUP_SIZE:           { //eq
		KEY:   _KEYS.CUP_SIZE,
		VALUE: {
			SMALL:       {KEY: 'SMALL', VALUE: {[_KEYS.CUP_SIZE]: {eq: 'SMALL'}}},
			MEDIUM:      {KEY: 'MEDIUM', VALUE: {[_KEYS.CUP_SIZE]: {eq: 'MEDIUM'}}},
			LARGE:       {KEY: 'LARGE', VALUE: {[_KEYS.CUP_SIZE]: {eq: 'LARGE'}}},
			EXTRA_LARGE: {KEY: 'EXTRA_LARGE', VALUE: {[_KEYS.CUP_SIZE]: {eq: 'EXTRA_LARGE'}}},
		}
	},
	SEXUALITY:          { //eq
		KEY:   _KEYS.SEXUALITY,
		VALUE: {
			STRAIGHT: {KEY: 'STRAIGHT', VALUE: {[_KEYS.SEXUALITY]: {eq: 'STRAIGHT'}}},
			BI:       {KEY: 'BI', VALUE: {[_KEYS.SEXUALITY]: {eq: 'BI'}}},
			GAY:      {KEY: 'GAY', VALUE: {[_KEYS.SEXUALITY]: {eq: 'GAY'}}},
		}
	},
	NEW:                { //eq bool
		KEY:   _KEYS.NEW,
		VALUE: {KEY: 'NEW', VALUE: {[_KEYS.NEW]: {eq: true}}},
	},
	SOFT_CHAT:          { //eq bool
		KEY:   _KEYS.SOFT_CHAT,
		VALUE: {KEY: 'SOFT', VALUE: {[_KEYS.SOFT_CHAT]: {eq: true}}},
	},
	LIVE_PREVIEW:       { //eq bool
		KEY:   _KEYS.LIVE_PREVIEW,
		VALUE: {KEY: 'LIVE', VALUE: {[_KEYS.LIVE_PREVIEW]: {eq: true}}},
	},
	TOY_CONTROL:        { //eq bool
		KEY:   _KEYS.TOY_CONTROL,
		VALUE: {KEY: 'TOY', VALUE: {[_KEYS.TOY_CONTROL]: {eq: true}}},
	},
	PHONE_SEX:          { //eq bool
		KEY:   _KEYS.PHONE_SEX,
		VALUE: {KEY: 'PHONE', VALUE: {[_KEYS.PHONE_SEX]: {eq: true}}},
	},
	BIRTHDAY:             { //eq bool
		KEY:   _KEYS.BIRTHDAY,
		VALUE: {KEY: 'birthday', VALUE: {[_KEYS.BIRTHDAY]: {eq: true}}},
	},
};

function setActiveFilterTags(filter, newFilter) {
	return [...filter].map(item => {
		item.tags.map((tag) => {
			if (newFilter.key === tag.key && tag.text === newFilter.text) {
				tag.isActive = !tag.isActive;
			}
		});
		//  item.tags = getSortedTopFilter(item.tags);
		return item;
	});
}


function generateModelsV3Filter(filter, withOnline = false) {
	if (filter.length < 1) {
		if (withOnline) {
			return ONLINE_FILTER;
		}
		return {};
	}
	const activeFilter = {and: []};
	const groups       = {};

	filter.map((tag) => {
		if (tag.type === 'tag') {
			if (!groups['tags']) {
				groups['tags'] = {'tags': {contains: []}};
			}
			groups['tags'].tags.contains.push(tag.value);
		} else {
			if (!groups[tag.key]) {
				groups[tag.key] = {or: []};
			}
			groups[tag.key].or.push(tag.value.VALUE);
		}
	});

	if (withOnline) {
		groups['online'] = {or: [ONLINE_FILTER]};
	}

	for (const key in groups) {
		activeFilter.and.push(groups[key]);
	}

	return activeFilter;
}

function getDefaultFilter() {
	//todo: workaround for default filter and guest preferences
	const isWomanFilterActive = Object.keys(VXConfig.guestPreferences || {}).length === 0;

	const FILTER = [
		{
			headline: ft('gender'),
			tags:     [
				{text: ft('woman'), key: _Filters.GENDER.KEY, value: _Filters.GENDER.VALUE.F, isActive: isWomanFilterActive},
				{text: ft('man'), key: _Filters.GENDER.KEY, value: _Filters.GENDER.VALUE.M},
				{text: ft('trans'), key: _Filters.GENDER.KEY, value: _Filters.GENDER.VALUE.S},
				{text: ft('couples'), key: _Filters.GENDER.KEY, value: _Filters.GENDER.VALUE.FM},
			]
		},
		{
			headline: ft('country'),
			tags:     [
				{text: ft('german'), key: _Filters.COUNTRY.KEY, value: _Filters.COUNTRY.VALUE.DE},
				{text: ft('spanish'), key: _Filters.COUNTRY.KEY, value: _Filters.COUNTRY.VALUE.ES},
				{text: ft('polish'), key: _Filters.COUNTRY.KEY, value: _Filters.COUNTRY.VALUE.PL},
				{text: ft('french'), key: _Filters.COUNTRY.KEY, value: _Filters.COUNTRY.VALUE.FR},
				{text: ft('russian'), key: _Filters.COUNTRY.KEY, value: _Filters.COUNTRY.VALUE.RU},
			]
		},
		{
			headline: ft('language'),
			hidden:   true,
			tags:     [
				{text: ft('german'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.DE, hidden: true},
				{text: ft('english'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.EN, hidden: true},
				{text: ft('french'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.FR, hidden: true},
				{text: ft('italy'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.IT, hidden: true},
				{text: ft('spanish'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.ES, hidden: true},
				{text: ft('da'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.DA, hidden: true},
				{text: ft('finnish'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.FI, hidden: true},
				{text: ft('netherlands'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.NL, hidden: true},
				{text: ft('polish'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.PL, hidden: true},
				{text: ft('pt'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.PT, hidden: true},
				{text: ft('russia'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.RU, hidden: true},
				{text: ft('tr'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.TR, hidden: true},
				{text: ft('czech'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.CZ, hidden: true},
				{text: ft('hungary'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.HU, hidden: true},
				{text: ft('romania'), key: _Filters.SPOKEN_LANGUAGES.KEY, value: _Filters.SPOKEN_LANGUAGES.VALUE.RO, hidden: true},
			]
		},
		{
			headline: ft('skin_color'),
			tags:     [
				{text: ft('asian'), key: _Filters.SKIN_TYPE.KEY, value: _Filters.SKIN_TYPE.VALUE.ASIAN},
				{text: ft('black'), key: _Filters.SKIN_TYPE.KEY, value: _Filters.SKIN_TYPE.VALUE.BLACK},
				{text: ft('latina'), key: _Filters.SKIN_TYPE.KEY, value: _Filters.SKIN_TYPE.VALUE.LATINA},
			]
		},
		{
			headline: ft('body'),
			tags:     [
				{text: ft('thin'), key: _Filters.BODY_TYPE.KEY, value: _Filters.BODY_TYPE.VALUE.THIN},
				{text: ft('bbw'), key: _Filters.BODY_TYPE.KEY, value: _Filters.BODY_TYPE.VALUE.FAT},
				{text: ft('average'), key: _Filters.BODY_TYPE.KEY, value: _Filters.BODY_TYPE.VALUE.AVERAGE},
				{text: ft('athletic'), key: _Filters.BODY_TYPE.KEY, value: _Filters.BODY_TYPE.VALUE.ATHLETIC},
			]
		},
		{
			headline: ft('body_art'),
			tags:     [
				{text: ft('tattoo'), key: _Filters.BODY_MODIFICATIONS.KEY, value: _Filters.BODY_MODIFICATIONS.VALUE.HEAVILYTATTOOED},
				/* {text: ft(''), key:_Filters.BODY_MODIFICATIONS.KEY, value: _Filters.BODY_MODIFICATIONS.VALUE.INTIMATETATTOO},*/
				{text: ft('piercing'), key: _Filters.BODY_MODIFICATIONS.KEY, value: _Filters.BODY_MODIFICATIONS.VALUE.PECTORALPIERCING},
				/*{text: 'Intimpiercing', key:_Filters.BODY_MODIFICATIONS.KEY, value: _Filters.BODY_MODIFICATIONS.VALUE.INTIMATEPIERCING},*/
			]
		},
		{
			headline: ft('hair_color'),
			tags:     [
				{text: ft('black_hair'), key: _Filters.HAIR_COLOR.KEY, value: _Filters.HAIR_COLOR.VALUE.BLACK, color: 'black'},
				{text: ft('blonde'), key: _Filters.HAIR_COLOR.KEY, value: _Filters.HAIR_COLOR.VALUE.BLOND, color: 'blond'},
				{text: ft('brown_hair'), key: _Filters.HAIR_COLOR.KEY, value: _Filters.HAIR_COLOR.VALUE.BROWN, color: 'brown'},
				{text: ft('red'), key: _Filters.HAIR_COLOR.KEY, value: _Filters.HAIR_COLOR.VALUE.RED, color: 'red'},
				{text: ft('multicolored'), key: _Filters.HAIR_COLOR.KEY, value: _Filters.HAIR_COLOR.VALUE.MULTICOLOURED, color: 'color'},
			]
		},
		{
			headline: ft('eye_color'),
			tags:     [
				{text: ft('blue'), key: _Filters.EYE_COLOR.KEY, value: _Filters.EYE_COLOR.VALUE.BLUE, color: 'blue'},
				{text: ft('brown'), key: _Filters.EYE_COLOR.KEY, value: _Filters.EYE_COLOR.VALUE.BROWN, color: 'brown'},
				{text: ft('green'), key: _Filters.EYE_COLOR.KEY, value: _Filters.EYE_COLOR.VALUE.GREEN, color: 'green'},
				{text: ft('gray'), key: _Filters.EYE_COLOR.KEY, value: _Filters.EYE_COLOR.VALUE.GREY, color: 'gray'},
			]
		},
		{
			headline: ft('age'),
			tags:     [
				{text: ft('teen'), key: _Filters.AGE.KEY, value: _Filters.AGE.VALUE.TEEN},
				{text: '18-29', key: _Filters.AGE.KEY, value: _Filters.AGE.VALUE["20-29"]},
				{text: '30-39', key: _Filters.AGE.KEY, value: _Filters.AGE.VALUE["30-39"]},
				{
					text:        ft('milf'),
					texts:       {
						[_Filters.GENDER.KEY]: {
							[_Filters.GENDER.VALUE.F.KEY]:  ft('milf'),
							[_Filters.GENDER.VALUE.FF.KEY]: ft('milf'),
							[_Filters.GENDER.VALUE.FM.KEY]: ft('milf'),
							[_Filters.GENDER.VALUE.M.KEY]:  ft('daddy'),
							[_Filters.GENDER.VALUE.S.KEY]:  ft('daddy'),
						}
					},
					key:         _Filters.AGE.KEY,
					value:       _Filters.AGE.VALUE.MILF,
					isActive:    false,
					isTopFilter: 4
				},
				{
					text:     ft('grandma'),
					texts:    {
						[_Filters.GENDER.KEY]: {
							[_Filters.GENDER.VALUE.F.KEY]:  ft('grandma'),
							[_Filters.GENDER.VALUE.FF.KEY]: ft('grandma'),
							[_Filters.GENDER.VALUE.FM.KEY]: ft('grandma'),
							[_Filters.GENDER.VALUE.M.KEY]:  ft('sixty_plus'),
							[_Filters.GENDER.VALUE.S.KEY]:  ft('sixty_plus'),
						}
					},
					key:      _Filters.AGE.KEY,
					value:    _Filters.AGE.VALUE.GRANDMA,
					isActive: false
				},
				{text: ft('birthday'), key: _Filters.BIRTHDAY.KEY, value: _Filters.BIRTHDAY.VALUE},
			]
		},
		{
			headline: ft('breasts'),
			hide:     {
				[_Filters.GENDER.KEY]: [_Filters.GENDER.VALUE.M.KEY]
			},
			tags:     [
				{text: ft('short'), key: _Filters.CUP_SIZE.KEY, value: _Filters.CUP_SIZE.VALUE.SMALL},
				{text: ft('normal'), key: _Filters.CUP_SIZE.KEY, value: _Filters.CUP_SIZE.VALUE.MEDIUM},
				{text: ft('tall'), key: _Filters.CUP_SIZE.KEY, value: _Filters.CUP_SIZE.VALUE.LARGE},
				{text: ft('mega'), key: _Filters.CUP_SIZE.KEY, value: _Filters.CUP_SIZE.VALUE.EXTRA_LARGE},
			]
		},
		{
			headline: ft('penis'),
			hide:     {
				[_Filters.GENDER.KEY]: [_Filters.GENDER.VALUE.F.KEY, _Filters.GENDER.VALUE.FF.KEY]
			},
			tags:     [
				{text: 'S', key: _Filters.PENIS_SIZE.KEY, value: _Filters.PENIS_SIZE.VALUE.S},
				{text: 'M', key: _Filters.PENIS_SIZE.KEY, value: _Filters.PENIS_SIZE.VALUE.M},
				{text: 'L', key: _Filters.PENIS_SIZE.KEY, value: _Filters.PENIS_SIZE.VALUE.L},
				{text: 'XL', key: _Filters.PENIS_SIZE.KEY, value: _Filters.PENIS_SIZE.VALUE.XL},
			]
		},
		{
			headline: ft('intimate_shaving'),
			tags:     [
				{text: ft('shaved'), key: _Filters.PUBIC_HAIR.KEY, value: _Filters.PUBIC_HAIR.VALUE.SHAVED},
				{text: ft('partially_shaved'), key: _Filters.PUBIC_HAIR.KEY, value: _Filters.PUBIC_HAIR.VALUE.PARTIALLY_SHAVED},
				{text: ft('hairy'), key: _Filters.PUBIC_HAIR.KEY, value: _Filters.PUBIC_HAIR.VALUE.HAIRY},
			]
		},
		{
			headline: ft('orientation'),
			tags:     [
				{text: ft('straight'), key: _Filters.SEXUALITY.KEY, value: _Filters.SEXUALITY.VALUE.STRAIGHT},
				{text: ft('bi'), key: _Filters.SEXUALITY.KEY, value: _Filters.SEXUALITY.VALUE.BI},
				{
					text:        ft('lesbian'),
					texts:       {
						[_Filters.GENDER.KEY]: {
							[_Filters.GENDER.VALUE.F.KEY]:  ft('lesbian'),
							[_Filters.GENDER.VALUE.FF.KEY]: ft('lesbian'),
							[_Filters.GENDER.VALUE.FM.KEY]: ft('lesbian'),
							[_Filters.GENDER.VALUE.M.KEY]:  ft('gay'),
							[_Filters.GENDER.VALUE.S.KEY]:  ft('gay'),
						}
					},
					key:         _Filters.SEXUALITY.KEY,
					value:       _Filters.SEXUALITY.VALUE.GAY,
					isActive:    false,
					isTopFilter: false
				},
			]
		},
		{
			headline: ft('quick_select'),
			tags:     [
				{text: ft('new_cams'), key: _Filters.NEW.KEY, value: _Filters.NEW.VALUE},
				{text: ft('softchat'), key: _Filters.SOFT_CHAT.KEY, value: _Filters.SOFT_CHAT.VALUE, isTopFilter: 6},
				{text: ft('livepreview'), key: _Filters.LIVE_PREVIEW.KEY, value: _Filters.LIVE_PREVIEW.VALUE, isTopFilter: 7},
				{text: ft('phonesex'), key: _Filters.PHONE_SEX.KEY, value: _Filters.PHONE_SEX.VALUE, isTopFilter: 8},
				{text: ft('toy_control'), key: _Filters.TOY_CONTROL.KEY, value: _Filters.TOY_CONTROL.VALUE, isTopFilter: 5},
			]
		},
		/*  {
			  headline: 'onlinestatus',
			  hidden: true,
			  tags: [
				  {text: 'DE', key: 'online', value: {VALUE: ONLINE_FILTER}, hidden: true, isActive: true},
			  ]
		  },*/
	];

	if (VXConfig.isOfficeIp) {
		FILTER.push({
			headline: 'onlinestatus',
			  hidden: true,
			  tags: [
				  {text: 'Videocall', key: _KEYS.MOBILE_VIDEOCALL, value: {KEY: _KEYS.MOBILE_VIDEOCALL, VALUE: {onlineMobileVideocall: {eq: true}}}, hidden: true, isTopFilter: 9},
			  ]
		});
	}

	const tagTopFilter = [
		{tag: 'anal', pos: 3},
		{tag: 'dominatrix', pos: 1},
		{tag: 'latex', pos: 2},
	];

	const groups = VXConfig.enumTagGroups.Cams;
	for (const key in groups) {
		if (groups.hasOwnProperty(key)) {
			const headline = Translations.get(`tags.${key}`);
			const tags     = groups[key].map(tag => ({
					text:        Translations.get('tags.' + tag),
					key:         headline,
					value:       Translations.get('tags.' + tag),
					isTopFilter: tagTopFilter.find(top => top.tag === tag) ? tagTopFilter.find(top => top.tag === tag).pos : false,
					isActive:    false,
					type:        'tag',
					tag:         tag
				}
			));
			FILTER.push({headline, tags});
		}
	}

	return FILTER;
}

export {
	getDefaultFilter,
	generateModelsV3Filter,
	setActiveFilterTags,
    ONLINE_FILTER
};
